import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { Typography, VerticalStepper } from 'seagull';
import styles from './Stepper.module.scss';
export function Stepper(param) {
    let { steps, activeStepIndex, activeSteps, onStepClick, completedSteps, testId } = param;
    const [completedStepperStep, setCompletedStepperStep] = useState(Math.max(activeStepIndex - 1, 0));
    useEffect(()=>{
        if (completedStepperStep < activeStepIndex - 1) {
            setCompletedStepperStep(activeStepIndex - 1);
        }
    }, [
        activeStepIndex,
        completedStepperStep
    ]);
    const stepperSteps = steps.map((text, i)=>{
        const disabled = i === activeStepIndex;
        return {
            component: /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: i === activeStepIndex ? 'bold' : 'light',
                className: cn(styles.stepperStep, !disabled ? styles.clickableStep : ''),
                children: text
            }),
            completed: completedSteps.includes(i),
            disabled: disabled,
            active: activeSteps.includes(i)
        };
    });
    return /*#__PURE__*/ _jsx(VerticalStepper, {
        steps: stepperSteps,
        activeStepIndex: activeStepIndex,
        onStepClick: onStepClick,
        testId: testId
    });
}
